module.exports = __webpack_public_path__ + "img/zyz-icon.b4c7fdd6.png";